import { Stack } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AccountMenu from '../../accountMenu/AccountMenu';
import UserNotifications from '../../notifications/UserNotifications';
import NavbarDropdowns from './NavbarDropdowns';

const logo = '/gainss-logo.png';

function NewNavbar() {
  const currentUser = JSON.parse(localStorage.getItem('user'));
  return (
    <AppBar
      sx={{
        zIndex: 1201,
        backgroundColor: '#f5f5f5',
        boxShadow: 'none',
        borderBottom: '1px solid #ddd',
      }}>
      <Container fluid className="px-3">
        <Toolbar
          disableGutters
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/dashboard" sx={{ cursor: 'pointer' }}>
              <img src={logo} width="125" alt="GAINSS" />
            </Link>
            <NavbarDropdowns />
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Stack direction="row" alignItems="center" spacing={1}>
              {currentUser?.role !== 'super-admin' && (
                <UserNotifications />
              )}
              <AccountMenu />
            </Stack>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default NewNavbar;
